interface Props {
  // In Application.JSON config app object can have a few use cases:
  // - no "AppEnv" field (equal C# `null` value)
  // - "AppEnv" field value as `null`. Yes, `null` is a valid JSON data type, but NOT `undefined` which will cause an error.
  // - "AppEnv" field value "" (empty string),
  // But on UI there is no requirement to render this component when appEnv value is null or empty string.
  value: string;
}

export function AppEnv(props: Readonly<Props>) {
  const { value } = props;

  return (
    <div
      data-testid="app-env-container"
      className="flex h-[14px] w-max items-center justify-center rounded-sm border border-4 border-black bg-black text-[8px] leading-[14px] font-bold tracking-wide text-white uppercase"
    >
      <span data-testid="app-env-value" className="relative top-[1px]">
        {value}
      </span>
    </div>
  );
}
